import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { budgetResetTypeOptions } from './BudgetResetTypeSelect.utils';

export interface BudgetResetTypeSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function BudgetResetTypeSelect({
  name,
  id,
  disabled,
}: BudgetResetTypeSelectProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label={<>&nbsp;</>}
      ariaLabel="Budget reset type"
      name={name}
      id={id}
      options={budgetResetTypeOptions}
      error={errors[name]}
      control={control}
      disabled={disabled}
      blockWidth
    />
  );
}
